const initialState = {
  data: null,
  loading: false,
  error: null,
  shabbat: null,
  shabbatLoading: false,
  shabbatError: null,
  hebrewDate: null,
  hebrewDateLoading: false,
  hebrewDateError: null
};

const zmanimReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ZMANIM_START':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'FETCH_ZMANIM_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case 'FETCH_ZMANIM_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case 'FETCH_HEBREW_DATE_START':
      return {
        ...state,
        hebrewDateLoading: true,
        hebrewDateError: null
      };

    case 'FETCH_HEBREW_DATE_SUCCESS':
      return {
        ...state,
        hebrewDateLoading: false,
        hebrewDate: action.payload,
        hebrewDateError: null
      };

    case 'FETCH_HEBREW_DATE_FAILURE':
      return {
        ...state,
        hebrewDateLoading: false,
        hebrewDateError: action.payload
      };

    case 'FETCH_ZMANIM_SHABBAT_START':
      return {
        ...state,
        shabbatLoading: true,
        shabbatError: null
      };

    case 'FETCH_ZMANIM_SHABBAT_SUCCESS':
      return {
        ...state,
        shabbatLoading: false,
        shabbat: action.payload,
        shabbatError: null
      };

    case 'FETCH_ZMANIM_SHABBAT_FAILURE':
      return {
        ...state,
        shabbatLoading: false,
        shabbatError: action.payload
      };

    default:
      return state;
  }
};

export default zmanimReducer;